import type { PlatformOSType } from "react-native";

type GetTabBarBottomOffsetArgs = {
  bottomInset: number;
  platform: PlatformOSType;
};

export const getTabBarBottomOffset = ({
  bottomInset,
  platform,
}: GetTabBarBottomOffsetArgs) => {
  if (platform === "web") {
    return bottomInset * 1.5;
  }

  if (platform === "android") {
    return bottomInset;
  }

  return 0;
};
